import { Stack } from '@mui/material';
import { z } from 'zod';

import { api } from 'common';

import { type AsynchronousJobVariant, OptionalStringSchema, RequiredStringSchema } from './common';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

import JobKind = api.RpaJob.Kind;

export const ExportGeneralCommentVariant: AsynchronousJobVariant = {
  schema: z.object({
    jobKind: z.literal(JobKind.ExportGeneralComment),
    payload: z.object({
      comment: RequiredStringSchema,
      ehrInformationId: RequiredStringSchema,
      patientFirstName: RequiredStringSchema,
      patientLastName: RequiredStringSchema,
      patientDateOfBirth: RequiredStringSchema,
      patientEhrId: RequiredStringSchema,
      patientSex: RequiredStringSchema,
      encounterEhrReferenceValue: RequiredStringSchema,
      encounterId: RequiredStringSchema,
      providerUserId: OptionalStringSchema,
    }),
  }),
  Config: () => {
    return (
      <Stack spacing={2}>
        <BlockValueTemplateField
          fieldName="config.payload.comment"
          label="Comment"
          helperText="Enter the comment to export"
          placeholder="e.g. Plain Text and {{block value template}} is supported"
        />
        <BlockValueTemplateField
          fieldName="config.payload.patientEhrId"
          label="MRN"
          helperText="Enter the reference to the patient's MRN. e.g. `{{patient.data.patientEhrId}}`"
          placeholder="e.g. {{patient.data.patientEhrId}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.patientFirstName"
          label="Patient First Name"
          helperText="Enter the reference to the patient's first name. e.g. `{{patient.data.firstName}}`"
          placeholder="e.g. {{patient.data.firstName}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.patientLastName"
          label="Patient Last Name"
          helperText="Enter the reference to the patient's last name. e.g. `{{patient.data.lastName}}`"
          placeholder="e.g. {{patient.data.lastName}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.patientDateOfBirth"
          label="Patient Date of Birth"
          helperText="Enter the reference to the patient's date of birth. e.g. `{{patient.data.dateOfBirth}}`"
          placeholder="e.g. {{patient.data.dateOfBirth}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.patientSex"
          label="Patient Sex"
          helperText="Enter the reference to the patient's sex. e.g. `{{patient.data.sex}}`"
          placeholder="e.g. {{patient.data.sex}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.encounterEhrReferenceValue"
          label="FIN"
          helperText="Enter the reference to the encounter's FIN. e.g. `{{encounter.data.ehrReferenceValue}}`"
          placeholder="e.g. {{encounter.data.ehrReferenceValue}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.encounterId"
          label="Notable Encounter ID"
          helperText="Enter the reference to the Notable Encounter ID. e.g. `{{encounter.data.id}}`"
          placeholder="e.g. {{encounter.data.id}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.ehrInformationId"
          label="Notable Ehr Information ID"
          helperText="Enter the reference to the Notable Ehr Information ID. e.g. `{{encounter.data.ehrInformationId}}`"
          placeholder="e.g. {{encounter.data.ehrInformationId}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.providerUserId"
          label="Notable Provider User ID"
          helperText="Enter the reference to the Notable Provider User ID e.g. `{{encounter.data.providerUserId}}`"
          placeholder="e.g. {{encounter.data.providerUserId}}"
        />
      </Stack>
    );
  },
};
